// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://portal.scheidfamilywines.com/',
  apiRequestBody:          '{"email": "{0}","user_id": "", "AllUser": 0,	"system": "{1}", "profileId": "{2}" }',
  apiRequestBody_children: '{"email": "{0}","user_id": "", "AllUser": 0,	"system": "{1}", "no": "{2}"}',
  apiUser:'eng.m.eldeaghedy@gmail.com',
  apiPassword:'123@qwe',
  esriTokenUrl: 'https://vitmap.scheidvineyards.com:6443/arcgis/tokens/generateToken',
  esriUser:'arcgis',
  esriPassword:'vit1Map',
  esriClient:'http://appshell.idbpro.com',
  fileFolderPath: 'C:\\inetpub\\wwwroot\\portal.scheidfamilywines.com',
  httpPath: 'https://portal.scheidfamilywines.com/files/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts